import { render, staticRenderFns } from "./AddInsBerth.vue?vue&type=template&id=6dd1e4d6&scoped=true&"
import script from "./AddInsBerth.vue?vue&type=script&lang=js&"
export * from "./AddInsBerth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd1e4d6",
  null
  
)

export default component.exports